export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-slate-50 py-12 px-4" data-testid="privacy-policy-page">
      <div className="max-w-3xl mx-auto bg-white rounded-2xl border border-slate-200 shadow-sm p-8 md:p-10">
        <h1 className="text-2xl md:text-3xl font-bold font-display text-slate-900 mb-2">Règles de confidentialité</h1>
        <p className="text-sm text-slate-500 mb-8">HSH Ops — Dernière mise à jour : septembre 2026</p>

        <div className="space-y-6 text-sm text-slate-700 leading-relaxed">
          <section>
            <h2 className="text-base font-bold text-slate-900 mb-2">1. Présentation</h2>
            <p>HSH Ops est une application interne de gestion opérationnelle de conciergerie immobilière (gestion d'appartements, d'anomalies, de ménage et de baux mobilité). Elle est destinée exclusivement à l'usage de l'équipe habilitée et de ses prestataires.</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-slate-900 mb-2">2. Données collectées</h2>
            <ul className="list-disc pl-5 space-y-1">
              <li>Comptes utilisateurs : nom, adresse e-mail, rôle et niveau d'accès.</li>
              <li>Appartements : adresses, caractéristiques, informations d'accès et photos.</li>
              <li>Baux mobilité : identité et coordonnées des locataires, dates de séjour, montants, contrats signés.</li>
              <li>Anomalies : descriptions, photos et historiques de traitement.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-base font-bold text-slate-900 mb-2">3. Intégrations Google (Gmail et Drive)</h2>
            <p>L'application utilise l'API Gmail pour envoyer les contrats et rappels aux locataires depuis l'adresse professionnelle de la conciergerie, et l'API Google Drive pour classer les contrats signés dans les dossiers de chaque appartement. Aucune donnée Google n'est revendue, partagée à des tiers, ni utilisée à des fins publicitaires.</p>
            <p className="mt-2">L'utilisation des informations reçues via les API Google respecte la <em>Google API Services User Data Policy</em>, y compris les exigences d'utilisation limitée (« Limited Use »).</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-slate-900 mb-2">4. Finalités et base légale</h2>
            <p>Les données sont traitées uniquement pour l'exécution des prestations de conciergerie (gestion des logements, contrats de bail mobilité, suivi opérationnel), sur la base de l'exécution du contrat et de l'intérêt légitime du gestionnaire.</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-slate-900 mb-2">5. Conservation et sécurité</h2>
            <p>Les contrats signés sont archivés dans Google Drive ; l'application ne conserve que l'historique minimal nécessaire (locataire, dates, montant, statut). Les accès sont protégés par authentification, niveaux de permission et liens sécurisés à expiration automatique. Les données sont hébergées sur une infrastructure cloud sécurisée.</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-slate-900 mb-2">6. Vos droits</h2>
            <p>Conformément au RGPD, vous disposez de droits d'accès, de rectification, d'effacement et d'opposition sur vos données personnelles. Pour les exercer, contactez : <a href="mailto:flavienfr3@gmail.com" className="text-blue-600 hover:underline">flavienfr3@gmail.com</a>.</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-slate-900 mb-2">7. Cookies</h2>
            <p>L'application utilise uniquement un cookie technique de session, nécessaire à l'authentification. Aucun cookie publicitaire ou de suivi n'est déposé.</p>
          </section>
        </div>

        <div className="mt-10 pt-6 border-t border-slate-100 text-xs text-slate-400">
          Contact : flavienfr3@gmail.com
        </div>
      </div>
    </div>
  );
}
